import { FunctionComponent, useRef } from "react";

import { FilterBar } from "@components/filter-bar/FilterBar";
import { FilterBarProps, Item } from "@components/filter-bar/FilterBar.types";
import { BpIdAuditLogArgs } from "@libs/api/gateways/bp-id/bp-id.dtos";

interface BpIdAuditLogsFilterProps
  extends Pick<FilterBarProps<BpIdAuditLogArgs>, "children"> {}

export const BpIdAuditLogsFilter: FunctionComponent<BpIdAuditLogsFilterProps> = props => {
  const defaultStartDate = new Date();
  defaultStartDate.setDate(defaultStartDate.getDate() - 7);
  const initialValues = useRef<BpIdAuditLogArgs>({
    startDate: defaultStartDate,
    endDate: new Date()
  });

  const auditLogSeverities: string[] = [
    "Information",
    "Warning",
    "Debug",
    "Error"
  ];

  const auditLogSources: string[] = ["OperationsApi", "SystemApi", "B2C"];

  const auditLogEventTypes: string[] = [
    "Invitation",
    "Login",
    "Signout",
    "LoginSettings",
    "LoginOptions",
    "Invitation",
    "MFA-Email",
    "MFA-Phone",
    "MFA-Authenticator"
  ];

  const items: Item<BpIdAuditLogArgs>[] = [
    {
      type: "datesRangePicker",
      name: "datesRangePicker",
      stickItem: true,
      props: {
        id: "usersigninlogs-filter-dates-range",
        startDateProps: { id: "usersigninlogs-filter-start-date" },
        endDateProps: { id: "usersigninlogs-filter-end-date" },
        startDateName: "startDate",
        endDateName: "endDate",
        placeholder: "Date(s)"
      }
    },
    {
      type: "optionsSelect",
      name: "severity",
      props: {
        placeholder: "Severity",
        hideSearchOption: true,
        multiSelect: true,
        options: auditLogSeverities.map(x => ({ key: x, text: x }))
      }
    },
    {
      type: "optionsSelect",
      name: "source",
      props: {
        placeholder: "Source",
        hideSearchOption: true,
        multiSelect: true,
        options: auditLogSources.map(x => ({ key: x, text: x }))
      }
    },
    {
      type: "optionsSelect",
      name: "eventType",
      props: {
        placeholder: "Event Type",
        hideSearchOption: true,
        multiSelect: true,
        options: auditLogEventTypes.map(x => ({ key: x, text: x }))
      }
    }
  ];

  return (
    <FilterBar {...props} items={items} initialValues={initialValues.current} />
  );
};
